import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { VirtualizedGridTable } from "#/components/ui/virtualized-grid-table";
import { useHyperAccount } from "#/hooks/use-hyperliquid-account";
import {
	createPortfolioPositionColumns,
	type PortfolioPositionRow,
} from "./positions-columns";

const GRID_CLASS =
	"grid min-w-[780px] grid-cols-[1.2fr_0.7fr_0.9fr_0.7fr_0.9fr_0.9fr_0.9fr] gap-3";

const coreRowModel = getCoreRowModel();

export function PositionsTable() {
	const { t } = useTranslate();
	const { positions, isError, refetch } = useHyperAccount();
	const columns = useMemo(() => createPortfolioPositionColumns(t), [t]);

	const table = useReactTable<PortfolioPositionRow>({
		data: positions,
		columns,
		getCoreRowModel: coreRowModel,
		enableSorting: false,
	});

	return (
		<div className="min-w-0">
			<h2 className="mb-4 text-body2-bold text-foreground">
				{t("portfolio.positions")}
			</h2>
			{/* Bounded height reserves space so the loading/empty→rows transition
			    doesn't shift the tables below it (portfolio CLS). VirtualizedGridTable's
			    flex-1 scroll machinery fills this like it does in the trade layout. */}
			<div className="flex min-h-48 max-h-80 flex-col">
				<VirtualizedGridTable
					table={table}
					gridClass={GRID_CLASS}
					estimateSize={36}
					emptyMessage={t("portfolio.no-positions")}
					isError={isError}
					onRetry={() => {
						refetch();
					}}
				/>
			</div>
		</div>
	);
}
